'use client';

import { CaretUp } from 'assets/icons';
import CustomLink from 'components/shared/CustomLink';
import { analytics } from 'lib/analytics/analytics';
import type { FoodSummary } from 'lib/ogdb/types';
import { FoodScoreComponent } from './FoodScoreComponent';
import { foodHref } from './types';
import styles from './FoodSuggestions.module.css';

export const FoodSuggestions = ({
  className,
  data,
}: {
  className?: string;
  data: FoodSummary[];
}) => {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <p>Other related foods</p>
      <ul>
        {data.map((suggestion, index) => {
          return (
            <li key={suggestion.food_id}>
              <CustomLink
                onClick={() => analytics.track('ogdb-suggestion')}
                data-link="ogdb-suggestions"
                href={foodHref(suggestion)}
              >
                <FoodScoreComponent
                  value={Math.round(Number(suggestion.average_score))}
                />
                {suggestion.url_friendly_name
                  ? suggestion.url_friendly_name.replaceAll('-', ' ')
                  : suggestion.name.split('(')[0]}
                <CaretUp
                  fill="rgba(255,255,255,0.1)"
                  style={{ transform: 'rotate(90deg)' }}
                  className={styles.caret}
                />
              </CustomLink>
              {index !== data.length - 1 ? (
                <hr className="seperator" />
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
